import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["menu"]

    connect() {
        this.boundClickOutside = this.clickOutside.bind(this)
    }

    toggleAddMenu(event) {
        event.stopPropagation()
        const menu = this.menuTarget

        // Close other open menus first
        document.querySelectorAll('.column-block-menu').forEach(el => {
            if (el !== menu) el.classList.add('hidden')
        })

        menu.classList.toggle('hidden')

        if (!menu.classList.contains('hidden')) {
            document.addEventListener('click', this.boundClickOutside)
        } else {
            document.removeEventListener('click', this.boundClickOutside)
        }
    }

    clickOutside(event) {
        if (!this.element.contains(event.target)) {
            this.closeAllMenus()
        }
    }

    closeAllMenus() {
        document.querySelectorAll('.column-block-menu').forEach(el => {
            el.classList.add('hidden')
        })
        document.removeEventListener('click', this.boundClickOutside)
    }
}
